export const deserializeLayouts = ({ id, displayName, layout, visible, specificNote, type } = {}) => {
  return {
    id,
    displayName,
    layout,
    visible,
    specificNote,
    type,
  };
};

export const serializeLayouts = (layout) => {
  const parsedLayout = JSON.parse(layout.layout);

  return {
    id: layout.id,
    displayName: layout.displayName,
    layout: parsedLayout,
    visible: layout.visible,
    specificNote: layout.specificNote,
  };
};



// WEBPACK FOOTER //
// src/actions/layout/serializers.js